<template>
  <Modal
    v-model="modalVisible"
    title="数据库表导入"
    @on-visible-change="change">
    <div style="padding: 20px">
      <RadioGroup v-model="dbName">
        <Radio v-for="(item,index) in dbArr" :label="item" :key="index"></Radio>
      </RadioGroup>
    </div>
    <div slot="footer">
      <Button size="large" @click="cancel">返回</Button>
      <Button type="primary" size="large" @click="ok">确定</Button>
    </div>
  </Modal>
</template>

<script>
  import Util from '@/libs/util.js';

  export default {
    name: 'ExportWin',
    data () {
      return {
        modalVisible: false,
        dbArr: [],
        dbName: null
      };
    },
    methods: {
      ok () {
        if(null==this.dbName){
          this.$Notice.error({
            title: '请先选择数据库表！'
          });
          return
        }
        this.$router.push({
          name: 'form-add',
          query: {
            tableName: this.dbName
          }

        });
      },
      change (flag) {
        if (!flag) {
          this.dbArr = [];
          this.dbName = null;
        } else {
          this.listDbTable();
        }
      },
      listDbTable () {
        let This = this;
        This.$http.get('/api/tables').then(function (response) {
          This.dbArr = response.data;
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      cancel () {
        this.modalVisible = false;
      }
    }

  };
</script>

<style scoped>
  .ivu-radio-wrapper {
    width: 210px;
  }
</style>
